import {Role} from 'common';

export const ROLE_DESCRIPTIONS: Record<Role, string> = {
    [Role.admin]           : `Volledig beheer: thema's, organisaties, gebruikers, KPI's en mijlpalen, de status van rapportage-items, alternatieve weergave, Vecozo en systeembeheer.`,
    [Role.reporter]        : `Rapporteren: invullen en indienen van de KPI's en mijlpalen van de eigen organisatie(s) en thema('s), inclusief het eigen beheer en het dashboard van de eigen organisatie(s).`,
    [Role.super_reporter]  : `Toegang tot de publieke API (via basic auth), onder andere voor de CSV-export van rapportage-items. Geeft zelf geen toegang tot het rapportagescherm.`,
    [Role.acceptant]       : `Beoordelen van ingediende items: te doen, geaccepteerd en afgewezen.`,
    [Role.reporter_manager]: `Beheer van rapporteurs: toevoegen, wijzigen en verwijderen van gebruikers met de rol Reporter en het synchroniseren met de inlog administratie.`,
    [Role.exporter]        : `Bedoeld voor exportrechten; deze rol geeft op dit moment nog geen extra toegang in de applicatie.`,
    [Role.dashboard_viewer]: `Alleen het dashboard: alle organisaties, zonder beheer en zonder uploads.`,
};

export const THEME_REMOVE_EMIT = 'theme-remove';
export const THEME_CHANGE_EMIT = 'theme-change';

export const ORGANIZATION_REMOVE_EMIT = 'organization-remove';
export const ORGANIZATION_CHANGE_EMIT = 'organization-change';

export const USER_REMOVE_EMIT = 'user-remove';
export const USER_CHANGE_EMIT = 'user-change';
// the strip ended a user's sessions, so the tab reloads the session overview
export const USER_SESSIONS_ENDED_EMIT = 'user-sessions-ended';

export const KPI_REMOVE_EMIT = 'kpi-remove';
export const KPI_CHANGE_EMIT = 'kpi-change';

export const DASHBOARD_TARGET_REMOVE_EMIT = 'dashboard-target-remove';
export const DASHBOARD_TARGET_CHANGE_EMIT = 'dashboard-target-change';

export const INITIATIEF_REMOVE_EMIT       = 'initiatief-remove';
export const INITIATIEF_CHANGE_EMIT       = 'initiatief-change';
export const FTE_TARGET_REMOVE_EMIT       = 'fte-target-remove';
export const FTE_TARGET_CHANGE_EMIT       = 'fte-target-change';
export const FINANCIELE_REGEL_REMOVE_EMIT = 'financiele-regel-remove';
export const FINANCIELE_REGEL_CHANGE_EMIT = 'financiele-regel-change';
